import React, {useRef, useState} from "react";
import {Store} from "../models/Store";
import CloseButtonImg from "../images/top__close-button.png";

export const OverlayVideo = () => {

    const myRef = useRef(null);

    // ワークショップモードの時は動画を表示しない
    const [visible, setVisible] = useState(!Store.isWorkshop);
    if (!visible) return (<div/>);

    return (
        <div className='top__overlay-video' ref={myRef} onClick={() => setVisible(false)} >
            <div>
                <iframe width="1120" height="700"
                        src="https://www.youtube.com/embed/nihejxEWXAI?autoplay=1&controls=0&iv_load_policy=0&modestbranding=1&rel=0&autoplay=1&fs=0"
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        title={'video1'}></iframe>
                <img className='top__close-button' src='img/overlay-video-close-button.png' width={29} height={29}
                     onClick={() => setVisible(false)} alt={''}/>
            </div>
        </div>
    );
};